import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import LinearProgress from '@material-ui/core/LinearProgress';
import injectSheet from 'react-jss';
import * as bookDownloadBarService from './bookDownloadBarService';
import ProgressBarButtons from './ProgressBarButtons';
import {
  getBooksSaving,
  getBookSynchronizing,
  isBookSaving,
  getClassroomBooksSynchronizing
} from '../../../utils/contentUtils';

const styles = {
  colorPrimary: {
    backgroundColor: '#99fcaa !important'
  },
  barColorPrimary: {
    backgroundColor: '#58bf6e !important'
  }
};

class BookDownloadBar extends React.Component {
  static propTypes = {
    bookId: PropTypes.string,
    classId: PropTypes.string,
    contentBooks: PropTypes.object,
    classes: PropTypes.object.isRequired,
    activitiesContent: PropTypes.object.isRequired,
    showButtons: PropTypes.bool,
    handlePauseRestart: PropTypes.func,
    handleCancel: PropTypes.func,
    pauseRestartIcon: PropTypes.string,
    wrapperClassName: PropTypes.string
  };

  renderProgressbarButton() {
    const { showButtons, handlePauseRestart, handleCancel, pauseRestartIcon } = this.props;
    return showButtons ? (
      <ProgressBarButtons
        key="progress-bar-buttons"
        pauseRestartIcon={pauseRestartIcon}
        handlePauseRestart={handlePauseRestart}
        handleCancel={handleCancel}
      />
    ) : (
      <div key="progress-bar-buttons" />
    );
  }

  isContentSaving(classId, bookId) {
    const { contentBooks } = this.props;

    if (bookId) {
      const contentBook = contentBooks[bookId];
      return isBookSaving(classId, contentBook);
    }
    const booksSaving = getBooksSaving(classId, contentBooks);
    return booksSaving.length ? booksSaving : undefined;
  }

  render() {
    const { bookId, classId, contentBooks, classes, activitiesContent, wrapperClassName } = this.props;
    const contentBook = contentBooks[bookId];
    const contentSaving = this.isContentSaving(classId, bookId);
    let buttonCancel = ' ';
    let content = <div />;
    if (contentSaving) {
      const downloadProgress = bookId
        ? bookDownloadBarService.downloadProgressData(contentBooks[bookId], activitiesContent, bookId, classId)
        : bookDownloadBarService.classroomDownloadProgress(contentBooks, activitiesContent, classId, contentSaving);
      content = <LinearProgress variant={'indeterminate'} />;
      if (downloadProgress.isUnzipping) {
        content = (
          <LinearProgress variant={'indeterminate'} value={downloadProgress.totalPercentage} classes={classes} />
        );
      } else if (downloadProgress.isDownloading && downloadProgress.totalPercentage > 0) {
        content = <LinearProgress value={downloadProgress.totalPercentage} variant="determinate" />;
        buttonCancel = this.renderProgressbarButton();
      }
    } else {
      const isSynchronizing = bookId
        ? getBookSynchronizing(bookId, contentBook)
        : getClassroomBooksSynchronizing(contentBooks, classId);
      if (isSynchronizing) {
        content = <LinearProgress variant={'indeterminate'} classes={classes} />;
      }
    }

    const progressBar = (
      <div key="progress-bar" className={wrapperClassName}>
        {content}
      </div>
    );
    return [progressBar, buttonCancel];
  }
}

function mapStateToProps(state) {
  return {
    contentBooks: state.content.contentBooks,
    activitiesContent: state.content.activitiesContent
  };
}

export default connect(mapStateToProps)(injectSheet(styles)(BookDownloadBar));
